import { useEffect } from 'react';
import { Button } from '@crazyegginc/hatch';

import { useModal } from '/src/hooks';
import { Modal } from '/src/contexts/modal';
import { RESOURCE_META } from '../../constants';

import { ReactComponent as OpenIcon } from '@crazyegginc/hatch/dist/images/icon-open-url-outline.svg';

const ZAPIER_SCRIPT_ID = 'zapier-elements-script';
const ZAPIER_STYLESHEET_ID = 'zapier-elements-stylesheet';
const ZAPIER_SCRIPT_SRC = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js';
const ZAPIER_STYLESHEET_HREF = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css';

let zapierAssetsPromise = null;

function ensureZapierAssets() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.resolve();
  }

  if (zapierAssetsPromise) {
    return zapierAssetsPromise;
  }

  zapierAssetsPromise = new Promise((resolve, reject) => {
    if (!document.getElementById(ZAPIER_STYLESHEET_ID)) {
      const stylesheet = document.createElement('link');
      stylesheet.id = ZAPIER_STYLESHEET_ID;
      stylesheet.rel = 'stylesheet';
      stylesheet.href = ZAPIER_STYLESHEET_HREF;
      document.head.appendChild(stylesheet);
    }

    const existingScript = document.getElementById(ZAPIER_SCRIPT_ID);
    if (existingScript) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = ZAPIER_SCRIPT_ID;
    script.type = 'module';
    script.src = ZAPIER_SCRIPT_SRC;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Zapier assets'));
    document.head.appendChild(script);
  }).catch((error) => {
    zapierAssetsPromise = null;
    throw error;
  });

  return zapierAssetsPromise;
}

export function ZapierModal({ notification, resourceType, resourceId, action, BackToModal }) {
  const modal = useModal();
  const { actionTextFn } = RESOURCE_META[resourceType];
  const actionText = actionTextFn(action);
  const editing = !!notification;

  useEffect(() => {
    ensureZapierAssets().catch(() => null);
  }, []);

  return (
    <Modal>
      <Modal.Title>{editing ? 'Edit Zapier Notification' : 'Get Notified via Zapier'}</Modal.Title>

      <div className="text-body-2">
        {editing
          ? `Data is being sent to Zapier ${actionText}. Log in to Zapier to edit or delete this Notification.`
          : `We’ll send data to Zapier ${actionText}. Log in to Zapier to create your Notification.`}
      </div>

      <Modal.Actions>
        <Button component="a" href="https://zapier.com/app/login" target="_blank" rel="noopener noreferrer">
          Log in to Zapier
          <OpenIcon className="ml-2.5 h-3 w-3 fill-current" />
        </Button>

        <Button
          variant="cancel"
          onClick={() =>
            BackToModal
              ? modal.show(<BackToModal resourceType={resourceType} resourceId={resourceId} action={action} />)
              : modal.close()
          }
          className="disabled:bg-transparent"
        >
          {editing ? 'Cancel' : 'Back'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
